import { red, yellow, green, blue } from '@material-ui/core/colors'

export const RED_YELLOW_BLUE = [red[500], yellow[500], blue[500]]



// WEBPACK FOOTER //
// ./src/theme/colors.js